export const ROLE = {
    SUPER_ADMIN: 1,
    SYSTEM_ADMIN: 1,
    ADMIN: 2,
    CUSTOMER: 3,
    SUPPLIER: 4
}
